import { MenuItem } from "@mui/material";
import SelectStyled from "./SelectStyled";

const OnlineOfflineSelector = ({name, label, onChange, ...props}) => {

    const OPTIONS = [
        { name:'Online', value: 'online' },
        { name:'Lokal', value: 'local'}
    ];

    const handleSelected = (event) => {
        if (onChange) {
            onChange(event);
        }
    }

    return (
        <>
            <SelectStyled
                fullWidth
                name={name}
                label={label}
                placeholder="Alle Workshops"
                variant="filled"
                inputProps={{ "aria-label": "Online oder lokal" }}
                onChange={handleSelected}
            >
                <MenuItem value="">Alle</MenuItem>
                {OPTIONS.map((option) => {
                    return <MenuItem key={option.value} value={option.value}>{option.name}</MenuItem>
                })}
            </SelectStyled>
        </>
    );

}

export default OnlineOfflineSelector;
